module.exports = "/images/vendor/desiigner-svg/svg/logos/edt-shop.svg?0acde025708a5c589e614b4f85da4b08";